import React from 'react';
import { withAuthenticator } from 'aws-amplify-react';
import Amplify, { Auth } from "aws-amplify";
import './assets/main.css';
import { configVariables } from './configs/configs'
import { CustLogin, CustForgotPassword, CustRequireNewPassword } from './components/authentication'
import AWSAppSyncClient from "aws-appsync";
import { ApolloProvider } from "@apollo/react-hoc";
import App from './App';
import  AWS  from 'aws-sdk'



Amplify.configure({
  region: configVariables.REGION, 
  userPoolId: configVariables.COGNITO_USERPOOL_ID,
  userPoolWebClientId: configVariables.COGNITO_USERPOOL_WEBCLIENT_ID, 
});



function MainApp() {
  const client = new AWSAppSyncClient({
    url: configVariables.ENDPOINT,
    region: configVariables.REGION,
    auth: {
      type: configVariables.AUTHENTICATION_TYPE,
      // jwtToken: signInUserSession.idToken.jwtToken, 
      jwtToken: async () =>(await Auth.currentSession()).getIdToken().getJwtToken()
      // apiKey: configVariables.API_KEY
    },
    disableOffline: true,
    complexObjectsCredentials: () => {
      return new AWS.Credentials({
        accessKeyId: configVariables.accessKeyId,
        secretAccessKey: configVariables.secretAccessKey
      });
    }
  });
  
  return (

    <ApolloProvider client={client}>
      <App/>
    </ApolloProvider>

  );
}

export default withAuthenticator(MainApp,false,[
  <CustLogin/>,
  <CustForgotPassword/>,
  <CustRequireNewPassword/>
]);

// export default withAuthenticator(App);
// 
// export default App;
